export enum Enviroment {
    dev = 0,
    homolog = 1,
    prod = 2,
}